module.exports = __webpack_public_path__ + "img/bigtimegaming.27e09f4b.svg";